<div class="card card-custom gutter-b card-strech">
    <div class="card-header card-header-tabs-line">
        <div class="card-toolbar">
            <ul class="nav nav-tabs nav-bold nav-tabs-line">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': metabolic }" data-toggle="tab" href="#pills-metabolic"
                        (click)="ver('metabolic')">
                        <span class="nav-text">Metabolic</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': envment }" id="pills-environment-tab" data-toggle="tab"
                        data-bs-target="#pills-environment" href="#pills-environment" (click)="ver('envment')">
                        Environment
                    </a>
                </li>
                 
              
            </ul>
        </div>
    </div>
    <div class="tab-content">
        <div class="tab-pane fade" [ngClass]="{ 'show active': metabolic }" id="pills-metabolic" role="tabpanel"
            aria-labelledby="pills-metabolic-tab">
            <ngx-work-profile-metabolic [pet_no]="pet_no"></ngx-work-profile-metabolic>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': envment }" id="pills-environment" role="tabpanel"
            aria-labelledby="pills-environment-tab">
            <ngx-work-profile-envment [pet_no]="pet_no"></ngx-work-profile-envment>
        </div>
    </div>
</div>